<script>
	import Sbox from './components/Sbox.svelte';
	import Callout from './components/Callout.svelte';
	import Footer from './components/footercomponent.svelte';
	// import Router from 'svelte-spa-router';
	// import routes from './routes';



	function doEventClick(event_name, event_location){

        if(event_location !== undefined){
			console.log(`sending (with redirect): ${event_name}`);
            window.dataLayer.push({
                'event': event_name,
                'eventCallback': ()=>{window.location.href = event_location;}
            });
        }else{
			console.log(`sending (without redirect): ${event_name}`);
            window.dataLayer.push({
                'event': event_name
            });
        }

		// gtag('event',event_name);
        // gtag('click',event_name);
        // gtag('event', 'Convert', event_name);
        // gtag('event', event_name, { 'debug_mode':true });
		// gtag('event','button_click', {
		// 	'event_name': event_name
		// });
		// setTimeout(()=>{
		// 	if(event_location !== undefined){
		// 		window.location.href=event_location;			 
		// 	}
		// }, 1000);
	}

</script>

<div class="pure-container" data-effect="pure-effect-fade">
    <input type="checkbox" id="pure-toggle-right" class="pure-toggle" data-toggle="right">
    <label class="pure-toggle-label" for="pure-toggle-right" data-toggle-label="right">
        <span class="pure-toggle-icon"></span>
    </label>

    <div class="pure-drawer" data-position="right">
        <div class="mobile-menu-container">
			<div class="mobile-menu-logo-container"><img src="/img/HomeEasy_logo_white-01.png" alt="HomeEasy by Semper Home Loans"></div>
			<div class="mobile-menu-sign-in-button-container">
				<button on:click={()=>{doEventClick('header_sign_in', undefined); }} class="black-button">Sign in</button>
			</div>
			<div class="mobile-menu-apply-now-button-container">
				<button on:click={()=>{
					doEventClick('header_apply_now', 'https://homeeasy.semperhl.com/borrower/onboarding/asksemper@semperhl.com?__hstc=41854589.110cc37d6bdf548d021533ecf92a4bf9.1643639078121.1645722245791.1645731614040.29&__hssc=41854589.2.1645731614040&__hsfp=1603130137');
					}}  class="black-button">Apply now</button>
			</div>
		</div>
    </div>
    <div class="pure-pusher-container">
        <div class="pure-pusher">
			<div class="main-container">

				<Sbox 
				div_id="navbar_desktop"
				desktop_styles="background-color: #2C313D;"
				mobile_styles="background-color: #2C313D;"
				>
					<div class="nav-container">
						<div class="nav-contents">
							<div class="nav-logo-container"><img src="/img/HomeEasy_logo_white-01.png" alt="HomeEasy by Semper Home Loans"></div>
							<div class="nav-link-container">
								<div class="nav-sign-in">
									<button on:click={()=>{doEventClick('header_sign_in', undefined);}}>Sign In</button>
								</div>
								<div class="nav-apply-now">
									<button  on:click={()=>{
					doEventClick('header_apply_now', 'https://homeeasy.semperhl.com/borrower/onboarding/asksemper@semperhl.com?__hstc=41854589.110cc37d6bdf548d021533ecf92a4bf9.1643639078121.1645722245791.1645731614040.29&__hssc=41854589.2.1645731614040&__hsfp=1603130137');
					}}  class="black-button">Apply now</button>
								</div>
							</div>
						</div>
					</div>
				</Sbox>
				<Sbox
				desktop_styles="background-color: #f9f9fa;background-repeat:no-repeat;background-size: cover; background-postion: center; background-image: url(/img/desktop_hero_header_t.png);"
				mobile_styles="background-color: #f9f9fa;background-repeat:no-repeat; background-size: cover; background-postion: center; background-image: url(/img/mobile_hero_header_t.png);"
				>
					<div class="hero-container">
						<div class="hero-easy-100-logo-container"><img src="/img/HE_100_DPA-01.svg" alt="Easy 100 Down Payment Assistance Program"></div>
						<div class="hero-title-container">Down Payment Assistance Program</div>
						<div class="hero-copy-container">An easier path to homeownership</div>
					</div>
				</Sbox>
				
				
				<Sbox
				desktop_styles="background-color: #f9f9fa;"
				mobile_styles="background-color: #f9f9fa;"
				>
					<div class="info1-container">
						<div class="info1-left-container">
							<div class="info1-left-title-container subheader-text">Program Overview</div>
							<div class="info1-left-copy-container first-icopy">An Easy solution for homeowners looking to purchase a home with ZERO down payment. Qualification focuses on the borrower’s ability to repay based on IN-HOUSE  common-sense UW</div>

							<div class="info1-left-title-container subheader-text">See if you qualify</div>
							<div class="info1-left-copy-container ">You can see if you qualify for our Easy 100 DPA 
								program in less than 60 seconds. </div>

							<div class="info1-left-button-container">
								<button on:click={()=>{
									doEventClick('overview_check_now', "https://apply.homeeasy100.com ");
									// window.location.href="https://apply.homeeasy100.com ";
									}}  class="red-button">Check now</button>
							</div>
						</div>
						<div class="info1-right-container">
							<div class="info1-right-title-container subheader-text">Program Highlights</div>
							<div class="info1-right-list-container">
								<ul>
									<li>Loan Amounts up to 647,200</li>
									<li>Income Limits are Greater of the 160% (SMI) State Median Income or AMI (Area Median Income)</li>
									<li>1-2 Units are eligible</li>
									<li>Rent can be used to qualify</li>
									<li>Standard FHA Loan Guidelines</li>
									<li>Minimum credit score 600</li>
									<li>No Debt-to-income restrictions (AUS Approval Required)</li>
									<li>No First-time Homebuyer Requirement</li>
									<!-- <li class="underlined">No payment or interest on the DPA Second mortgage! </li> -->
									<li class="underlined">Close in 30 days or less</li>
									<li class="underlined">No State agency involved. 100% in-House underwritten, funded, and serviced!</li>
								</ul>
							</div>
				
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #f9f9fa;"
				mobile_styles="background-color: #f9f9fa;"
				>
					<div class="info2-container">
						<div class="info2-title-container subheader-text">3 simple ways to get Easy 100 DPA approved</div>
						<div class="info2-callout-container">
							<Callout
								img_url="/img/House_2.svg"
								button_title="Apply now"
								button_event="callout_apply_now"
								button_link="https://homeeasy.semperhl.com/borrower/onboarding/asksemper@semperhl.com?__hstc=41854589.110cc37d6bdf548d021533ecf92a4bf9.1643639078121.1645722245791.1645731614040.29&__hssc=41854589.2.1645731614040&__hsfp=1603130137"
							>
							Apply with Semper Home Loans
							</Callout>
							<Callout
								img_url="/img/Card_phone.svg"
								button_title="Call now"
								button_event="callout_call_now"
								button_link="tel:866-604-5130"
							>
							Speak with a loan consultant now.
							</Callout>
							<Callout
								img_url="/img/Calendar_check.svg"
								button_title="Book appointment"
								button_event="callout_book_appointment"
								button_link="https://outlook.office365.com/owa/calendar/SemperHomeLoans4@semperhl.com/bookings/"
							>
							Make an appointment to talk later
							</Callout>
						</div>
				
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #eaeff1;"
				mobile_styles="background-color: #eaeff1;"
				>
					<div class="home-ownership-container">
						<div class="home-ownership-left-container">
							<div class="home-ownership-left-img-container"><img src="/img/new_homeowners.png" alt=""></div>
						</div>
						<div class="home-ownership-right-container">
							<div class="home-ownership-right-title-container subheader-text">Homeownership starts here</div>
							<div class="home-ownership-right-copy-container">Buying a home as a first-time homebuyer can seem daunting, and that's why we're here to help. We will help you learn how to save and  prepare for your home purchase, connect you with real estate professionals, teach you the mortgage process, and so much more.</div>
							<div class="home-ownership-right-button-container">
								<button  on:click={()=>{doEventClick('homeownership_apply_now', 'https://homeeasy.semperhl.com/borrower/onboarding/asksemper@semperhl.com?__hstc=41854589.110cc37d6bdf548d021533ecf92a4bf9.1643639078121.1645722245791.1645731614040.29&__hssc=41854589.2.1645731614040&__hsfp=1603130137');}}  class="red-button">Apply now</button>
							</div>
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #2C313D;"
				mobile_styles="background-color: #2C313D;"
				>
					<div class="first-time-container">
						<div class="first-time-left-container">
							<div class="first-time-left-img-container">
								<img src="/img/House-02.png" alt="house">
							</div>
						</div>
						<div class="first-time-right-container">
							<div class="first-time-right-title-container subheader-text">Mortgages for first-time homebuyers</div>
							<div class="first-time-right-copy-container">100 DPA is the easy solution for first-time buyers, and we're here to help you through the process.</div>
							<div class="first-time-right-button-container">
								<button  on:click={()=>{window.location.href="https://homeeasy.semperhl.com/borrower/onboarding/asksemper@semperhl.com?__hstc=41854589.110cc37d6bdf548d021533ecf92a4bf9.1643639078121.1645722245791.1645731614040.29&__hssc=41854589.2.1645731614040&__hsfp=1603130137";}}  class="red-button">Apply now</button>
							</div>
				
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #f9f9fa;"
				mobile_styles="background-color: #f9f9fa;"
				>
					<div class="features-container">
						<div class="features-title-container subheader-text">Other features and benefits</div>
						<div class="features-list-main-container">
							<div class="features-list-left-container">
				
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img src="/img/Credit_card-01.png" alt="credit card">
									</div>
									<div class="features-list-copy-container">
										Offered to you free of charge
									</div>
								</div>
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img src="/img/Gear-01.png" alt="gear">
									</div>
									<div class="features-list-copy-container">
										Tracks your progress so you can pause and resume  anytime, anywhere
									</div>
								</div>
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img src="/img/Ribbon-02.png" alt="Ribbon">
									</div>
									<div class="features-list-copy-container">
										Provides a 15-question end of course quiz, which you can take as many times as needed to pass
									</div>
								</div>
								
							</div>
							<div class="features-list-right-container">
				
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img src="/img/Clock-01.png" alt="clock">
									</div>
									<div class="features-list-copy-container">
										Takes 3-4 hours to complete all 7 modules
									</div>
								</div>
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img src="/img/Computer-01.png" alt="computer">
									</div>
									<div class="features-list-copy-container">
										Accessible from your desktop, tablet or mobile device
									</div>
								</div>
								<div class="features-list-container">
									<div class="features-list-icon-container">
										<img  src="/img/Cloud-01.png" alt="cloud">
									</div>
									<div class="features-list-copy-container">
										Return to your course anytime to use the tools and information as a resource, as often as you’d like
									</div>
								</div>
								
							</div>
						</div>
						<div class="features-button-container">
							<button class="red-button">Start course</button>
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #ffffff;"
				mobile_styles="background-color: #ffffff;"
				>
					<div class="join-us-container">
						<div class="join-us-left-container">
							<div class="join-us-left-title-container subheader-text">Join us today</div>
							<div class="join-us-left-copy-container">If you want to work with a lender with multifaceted lending products as an approved realtor, we invite you to join our team.</div>
							<div class="join-us-left-button-container">
								<button  on:click={()=>{doEventClick('join_us_contact_us', 'https://asksemper.zendesk.com/hc/en-us');}}  class="red-button">Contact us</button>
							</div>
				
						</div>
						<div class="join-us-right-container">
							<div class="join-us-right-img-container"><img src="/img/circles.png" alt="circles"></div>
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #ffffff; margin-top: 150px; margin-bottom: 150px;"
				mobile_styles="background-color: #ffffff; margin-top: 80px; margin-bottom: 80px;"
				>
					<div class="about-us-container">
						<div class="about-us-left-container">
							<div class="about-us-left-title-container subheader-text">About us</div>
							<div class="about-us-left-copy-container">Semper provides all homebuyers with the tools and information needed to achieve homeownership. We believe that a well-informed homebuyer is a more powerful homebuyer, and we're here to help you.</div>
							<div class="about-us-left-button-container">
								<button class="black-hover"   on:click={()=>{doEventClick('semper_home_loans_faqs', 'https://asksemper.zendesk.com/hc/en-us');}} >Semper Home Loans FAQs</button>
							</div>
							<div class="about-us-left-help-container">
								<div class="about-us-left-help-icon-container"><img src="/img/Headset-01.png" alt="Headset"></div>
								<div class="about-us-left-help-copy-container">Need help? Call us: (866) 604-5130</div>
							</div>
				
						</div>
						<div class="about-us-right-container">
							<div class="about-us-right-img-container"><img src="/img/blue_house.png" alt="blue house"></div>
						</div>
					</div>
				</Sbox>
				
				<Sbox
				desktop_styles="background-color: #f9f9fa;"
				mobile_styles="background-color: #f9f9fa;"
				>
					<div class="footer-container">
						<Footer
							show_top_border={false}
						/>
					</div>
				</Sbox>
				</div>
							
        </div>
    </div>
    <label class="pure-overlay" for="pure-toggle-left" data-overlay="left"></label>
</div>


<style>
	.main-container {
		width: 100vw;
		font-size: 1em;
		line-height: 1.75em;
		position: relative;
	}
	/* navbar */
	:global(#navbar_desktop) {
		position: fixed !important;
		top: 0;	
  		width: 100%;	
		z-index: 999 !important;
	}
	.nav-container {
		background-color: #2C313D;
		color: white;
	}
	.nav-contents {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 16px;
		padding-bottom: 16px;
	}
	.nav-logo-container {
		height: 50px;
	}
	.nav-logo-container img {
		height: 100%;
	}
	.nav-link-container {
		display: flex;
		align-items: center;
	}
	.nav-sign-in button, .nav-apply-now button {
		background-color: var(--eclipse);
		color: var(--bg_white);
		font-size: 1.25em;
		font-weight: bold;
		padding: 20px 40px;
		cursor: pointer;
	}
	.nav-sign-in button {
		border: none;
	}
	.nav-sign-in button:hover, .nav-sign-in button:focus {
		text-decoration: underline;
	}
	
	.nav-apply-now button {
		border-style: solid;
		border-width: 2px;
		border-radius: 5px;
		border-color: var(--bg_white);
	}
	/* hero */
	.hero-container {
		background-color: none;
		color: white;
		height: 470px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-top: 131px;
	}
	.hero-easy-100-logo-container {
		margin-top: -60px;
		height: 48px;
	}
	.hero-easy-100-logo-container img {
		height: 100%;
	}
	.hero-title-container {
		font-size: 3em;
		font-weight: bold;
		padding: 10px 0px;
	}
	.hero-copy-container {
		font-size: 1.5em;
	}
	/* info1 */
	.info1-container {
		color: var(--eclipse);
		display: flex;
		margin-top: -60px;
	}
	.info1-left-container, .info1-right-container {
		display: flex;
		flex-direction: column;
		padding: 50px 50px;
	}
	.info1-left-container {
		flex: 1;
		background-color: var(--bg_white);
	}
	.info1-left-copy-container {
		font-size: 1.25em;
	}
	.first-icopy {
		padding-bottom: 50px;
	}
	.info1-right-container {
		flex: 1;
		background-color: var(--bg_gray);
	}
	.info1-right-list-container {
		font-size: 1em;
	}
	.info1-right-list-container ul li.underlined {
		/* text-decoration: underline; */
		color: var(--semperred) !important;
	}
	.info1-right-list-container ul {
		padding-left: 20px;
	}

	/* info2 */
	.info2-container {
		color: var(--eclipse);
		display: flex;
		flex-direction: column;
		padding: 150px 50px;
	}
	.info2-title-container {
		text-align: center;
		max-width: 900px;
		margin-left: auto;
		margin-right: auto;
		font-size: 1.5em !important;
		line-height: 1.5em !important;
	}
	.info2-callout-container {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		padding-top: 40px;
		padding-bottom: 150px;
	}


	/* home ownership */
	.home-ownership-container {
		color: var(--eclipse);
		display: flex;
		flex-direction: row;
	}
	.home-ownership-left-container {
		flex: 1;
		position: relative;
	}
	.home-ownership-left-img-container {
		width: 730px;
		position: absolute;
		bottom: -49px;
		right: 0px
	}
	.home-ownership-left-img-container img{
		width: 100%;
	}
	.home-ownership-right-container {
		flex: 1;
		padding: 150px 50px;
	}
	
	/* first time */
	.first-time-container {
		background-color: #2C313D;
		color: white;
		display: none;
		flex-direction: row;
	}
	.first-time-left-container {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-right: 50px;
	}
	.first-time-left-img-container {
		width: 250px;
		isolation: isolate;
		position: relative;
	}
	.first-time-left-img-container::before {
		content: ' ';
		position: absolute;
		background-color: #657680;
		width: 240px;
		height: 240px;
		border-radius: 50%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: -1;
	}
	.first-time-left-container img {
		width: 100%;
	}
	.first-time-right-container {
		padding: 150px 50px;
	}

	/* features */
	.features-container {
		color: var(--eclipse);
		padding: 150px 0px;
		display: none;
	}
	.features-list-main-container {
		display: flex;
		flex-direction: row;
		padding: 50px 0px;
	}
	.features-list-left-container, .features-list-right-container {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
	.features-list-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		padding: 20px 0px;
	}
	.features-list-icon-container {
		width: 40px;
		min-width: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.features-list-icon-container img {
		width: 100% !important;
	}
	.features-list-copy-container {
		padding-left: 30px;
		padding-right: 30px;
	}
	.features-button-container {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}


	/* infjoin uso1 */
	.join-us-container {
		color: white;
		background-color: var(--eclipse);
		height: 450px;
		display: flex;
		flex-direction: row;
		padding: 0px 100px;
		border-radius: 5px;
		margin-top: 150px;
	}
	.join-us-left-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.join-us-right-container {
		flex: 1;
		display: flex;
		flex-direction: row-reverse;
	}
	.join-us-right-img-container {
		height: 100%;
	}
	.join-us-right-img-container img {
		height: 100%;
	}

	/* about us */
	.about-us-container {
		color: var(--eclipse);
		display: flex;
		padding: 50px 0px;
	}
	.about-us-left-container, .about-us-right-container {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.about-us-left-container {
		display: flex;
		flex-direction: column;
	}
	.about-us-left-copy-container {
		padding-right: 100px;
		padding-bottom: 30px;
		font-size: 1em;
		line-height: 1.75em;
	}
	.about-us-left-help-container {
		display: flex;
		align-items: center;
		padding-top: 40px;
	}
	.about-us-left-help-icon-container {
		height: 30px;
	}
	.about-us-left-help-icon-container img {
		height: 100%;
	}
	.about-us-left-help-copy-container {
		padding-left: 20px;
	}
	.about-us-left-button-container button {
		border: solid 2px #2C313D;
		background-color: white;
		border-radius: 5px;
		padding: 20px 40px;
		font-weight: bold;	
		cursor: pointer;
	}
	.about-us-left-button-container button:hover {
		background-color: #2C313D !important;
		color: white !important;
	}
	.about-us-right-container {
		width: 100%;
	}
	.about-us-right-container img{
		width: 100%;
	}

	/* footer */
	.footer-container {
		color: #747b84;
	}
	.pure-toggle-label {
		display: none;
	}

@media (max-device-width: 1024px), (max-width: 1023px) {
	.main-container {
		font-size: 1em;
		line-height: 1.5em;
	}
	.nav-contents {
		padding-left: 20px;
		padding-right: 20px;
		/* padding-top: 32px; */
		/* padding-bottom: 32px; */
	}
	.nav-link-container {
		display: none;
	}
	.nav-logo-container {
		height: auto;
		width: 50% !important;
		max-width: 50% !important;
	}
	.nav-logo-container img {
		height: auto;
		width: 100%;
	}


	.hero-container {
		height: 240px;
		padding-left: 20px;
		padding-right: 20px;
	}
	.hero-easy-100-logo-container {
		margin-top: 0px;
	}
	.hero-title-container {
		font-size: 1.75em !important;
		line-height: 1.5em !important;
		font-weight: bold;
		padding: 0px 0px;
	}
	.hero-copy-container {
		font-size: 1.25em !important;
	}
	.info1-container {
		flex-direction: column;
		margin-top: 0px;
	}
	.info1-left-container, .info1-right-container {
		display: flex;
		flex-direction: column;
		padding: 40px 20px;
	}
	.info2-container {
		padding: 80px 20px;
	}
	.info2-title-container {
		text-align: center;
		max-width: 90%;
		margin-left: auto;
		margin-right: auto;
	}
	.info2-callout-container {
		flex-direction: column;
	}
	.home-ownership-container {
		flex-direction: column;
		padding-bottom: 50px;
	}
	.home-ownership-left-container {
		flex: auto;
		height: 330px;
	}
	.home-ownership-right-container {
		flex: auto;
		padding: 40px 20px;
	}
	.home-ownership-left-img-container {
		width: 90%;
		position: absolute;
		bottom: -10px;
		left: 50%;
		transform: translate(-50%, 0%);
		right: auto;
	}
	.first-time-container {
		flex-direction: column;
	}
	.first-time-left-container {
		padding-top: 150px;
		padding-right: 0px;
	}
	.first-time-right-container {
		padding: 80px 20px;
		padding-top: 150px;
	}
	.features-container {
		padding: 80px 20px;
	}
	.features-list-main-container {
		flex-direction: column;
		padding: 30px 0px;
	}
	.features-button-container {
		justify-content: flex-start;
		align-items: center;
	}
	.join-us-container {
		margin-left: 20px !important;
		margin-right: 20px !important;
		padding: 0px 20px;
		height: 450px;
		isolation: isolate;
		position: relative;
		margin-top: 80px;
	}
	.join-us-container::after {
		content: ' ';
		height: 450px;
		width: 200px;
		position: absolute;
		right: 0px;
		top: 0px;
		background-image: url(/img/circles.png);
		z-index: -1;
	}
	.join-us-right-container {
		display: none;
	}
	.join-us-left-title-container {
		font-size: 2em !important;
	}
	.join-us-left-copy-container {
		font-size: 1.5em !important;
		line-height: 1.5em;
		font-weight: bold;
	}
	.join-us-left-button-container button{
		font-size: 1.75em;
	}
	.about-us-container {
		padding: 80px 20px;
	}
	.about-us-left-copy-container {
		padding-right: 0px;
	}
	.about-us-left-button-container button {
		width: 100%;
	}
	.about-us-left-button-container button {
		width: 100%;
	}
	.about-us-right-container {
		display: none;
		padding: 0px
	}
	.pure-toggle-label {
		display: block;
		margin-top: -10px;
	}
	.mobile-menu-container {
		width: 100%;
		height: 100%;
		background-color: var(--eclipse);
		padding: 32px 20px;
		display: flex;
		flex-direction: column;
		overflow-y: scroll;
	}
	.mobile-menu-logo-container {
		height: auto;
		width: 50% !important;
		max-width: 50% !important;
	}
	.mobile-menu-logo-container img {
		height: auto;
		width: 100%;
	}
	.mobile-menu-sign-in-button-container {
		margin-top: 50px;
	}
	.mobile-menu-sign-in-button-container, .mobile-menu-apply-now-button-container {
		width: 100%;
		padding: 30px 20px;
	}
	.black-button {
		width: 100%;
		cursor: pointer;
	}
}


</style>
